module.exports = __webpack_public_path__ + "img/d18af48.png";